module.exports = __webpack_public_path__ + "static/media/26.3bacc99a.JPG";